<div class="tw-grid tw-gap-6 tw-grid-cols-1 md:tw-grid-cols-2 xl:tw-grid-cols-3 2xl:tw-grid-cols-2">
  <!-- Render File Cards -->
  <app-file-card
    *ngFor="let file of files; let i = index"
    [fileItem]="file"
    [methodName]="methodName"
    [service]="service"
    (deleteCard)="onDeleteCard(file)"
  ></app-file-card>

  <!-- Add New Card Button -->
  <div
    class="hover:!tw-bg-primary-100 hover:dark:!tw-bg-dark-200 !tw-h-[470px]  tw-gap-2 tw-rounded-lg !tw-border-[3px] !tw-border-dashed !tw-border-primary-500 tw-flex tw-items-center tw-justify-center tw-cursor-pointer"
    (click)="addNewCard()"
  >
    <span
      class="mdi mdi-plus tw-text-primary-500 !tw-font-bold !tw-text-[50px]"
    ></span>
  </div>
</div>
